module.exports = __webpack_public_path__ + "static/media/CourseStatus_Completed.827e7f0f.svg";